import { HTTPError } from './errors';
import { SuccessResponse } from './types';

export const createQuery = (baseInit?: RequestInit) => <TResponse extends SuccessResponse>(
  url: string,
  init?: RequestInit
) => fetch(
    url,
    { ...baseInit, ...init }
  )
    .then(async (res) => {
      const response = await res.json();

      if (!res.ok) throw new HTTPError(res.status, res.statusText, response);

      return response as TResponse;
    });

const query = createQuery({ credentials: 'include' });

const makeRequest = (
  method: RequestInit['method']
) => <TResponse extends SuccessResponse, TBody = Record<string, unknown>>(
  url: string,
  body: TBody
) => query<TResponse>(url, {
  method,
  body: body ? JSON.stringify(body) : undefined,
});

export const api = {
  get: query,
  post: makeRequest('POST'),
  delete: makeRequest('DELETE'),
  put: makeRequest('PUT'),
  patch: makeRequest('PATCH'),
};
